import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectToken } from "../../../../../../redux-store/selectors";
import { activateWorkingHoursScheduleAction } from "../../../../constants/actions";
import {
  activateWorkingHoursScheduleFailure,
  activateWorkingHoursScheduleSuccess,
  activateWorkingHoursSchedule,
} from "../../../actions/Manager/Settings/workingHoursActions";
import { notify } from "react-notify-toast";
import { activateWorkingHoursScheduleApi } from "../../../../axios/Manager";
import { union } from "ts-action";
import { translate } from "../../../../../../helpers/translate";
import Strings from "../../../../i18n/strings/brandOpeningHours";

const t = translate("brandOpeningHours");
const actionTypes = union({ activateWorkingHoursSchedule });
export function* activateWorkingHoursScheduleSaga({
  payload,
}: typeof actionTypes) {
  try {
    const token = yield select(selectToken);
    const { scheduleId, store_id } = payload;
    const response = yield call(
      activateWorkingHoursScheduleApi,
      token,
      scheduleId,
      store_id
    );
    yield put(activateWorkingHoursScheduleSuccess(scheduleId));
    notify.show(
      t(Strings.workingHoursScheduleActivatedSuccessfully),
      "success"
    );
  } catch (error) {
    yield put(activateWorkingHoursScheduleFailure(error as Error));
    notify.show(t(Strings.somethingWentWrong), "error");
  }
}

export function* watchActivateWorkingHoursSchedule() {
  yield takeLatest(
    activateWorkingHoursScheduleAction.requested,
    activateWorkingHoursScheduleSaga
  );
}
